/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var SendPaperplaneIcon24Solid = forwardRef('SendPaperplaneIcon24Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M21.14 10.383 5.152 2.413c-1.074-.535-2.295.396-2.062 1.573l1.172 5.95A1.445 1.445 0 0 0 5.68 11.1h6.072a.9.9 0 0 1 0 1.8H5.68c-.69 0-1.285.488-1.418 1.165l-1.172 5.94c-.232 1.177.988 2.108 2.062 1.573l15.987-7.962c1.335-.665 1.335-2.569 0-3.234Z" })));
});
